/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Geliver_Substatus_Delivery_RescheduledInputs */

const tr_geliver_substatus_delivery_rescheduled = /** @type {(inputs: Geliver_Substatus_Delivery_RescheduledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teslimat Yeniden Planlandı`)
};

const en_geliver_substatus_delivery_rescheduled = /** @type {(inputs: Geliver_Substatus_Delivery_RescheduledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delivery Rescheduled`)
};

const de_geliver_substatus_delivery_rescheduled = /** @type {(inputs: Geliver_Substatus_Delivery_RescheduledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lieferung neu geplant`)
};

const ru_geliver_substatus_delivery_rescheduled = /** @type {(inputs: Geliver_Substatus_Delivery_RescheduledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Доставка перенесена`)
};

/**
* | output |
* | --- |
* | "Delivery Rescheduled" |
*
* @param {Geliver_Substatus_Delivery_RescheduledInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const geliver_substatus_delivery_rescheduled = /** @type {((inputs?: Geliver_Substatus_Delivery_RescheduledInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Geliver_Substatus_Delivery_RescheduledInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_geliver_substatus_delivery_rescheduled(inputs)
	if (locale === "de") return de_geliver_substatus_delivery_rescheduled(inputs)
	if (locale === "ru") return ru_geliver_substatus_delivery_rescheduled(inputs)
	return tr_geliver_substatus_delivery_rescheduled(inputs)
});